// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file booking/v1/booking.proto (package booking.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Ancillary, RentalVehicleBooking, RentalVehiclePrebook, SelectedAncillary, TaxiBooking, TaxiPrebook, TrainBooking, TrainPrebook, TrainRecapSegment } from "./booking_detail_pb";
import { file_booking_v1_booking_detail } from "./booking_detail_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { PrimaryTransportRef } from "../../mission/v1/mission_pb";
import { file_mission_v1_mission } from "../../mission/v1/mission_pb";
import type { CO2Emission, Fare, Flags, Passenger, Price, RentalVehicleDriver, Transport, TransportAgency, TransportLeg, TransportType } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { VehicleProperties } from "../../mobility/v1/vehicle_pb";
import { file_mobility_v1_vehicle } from "../../mobility/v1/vehicle_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file booking/v1/booking.proto.
 */
export const file_booking_v1_booking: GenFile = /*@__PURE__*/
  fileDesc("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", [file_booking_v1_booking_detail, file_google_protobuf_duration, file_google_protobuf_timestamp, file_mission_v1_mission, file_mobility_v1_common, file_mobility_v1_vehicle]);

/**
 * PrebookTransportRequest - holds a primary transport option on an already-seeded BookingItem.
 *
 * @generated from message booking.v1.PrebookTransportRequest
 */
export type PrebookTransportRequest = Message<"booking.v1.PrebookTransportRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from oneof booking.v1.PrebookTransportRequest.transport
   */
  transport: {
    /**
     * @generated from field: booking.v1.TrainPrebook train = 3;
     */
    value: TrainPrebook;
    case: "train";
  } | {
    /**
     * @generated from field: booking.v1.TaxiPrebook taxi = 4;
     */
    value: TaxiPrebook;
    case: "taxi";
  } | {
    /**
     * @generated from field: booking.v1.RentalVehiclePrebook rental_vehicle = 5;
     */
    value: RentalVehiclePrebook;
    case: "rentalVehicle";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message booking.v1.PrebookTransportRequest.
 * Use `create(PrebookTransportRequestSchema)` to create a new message.
 */
export const PrebookTransportRequestSchema: GenMessage<PrebookTransportRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 0);

/**
 * PrebookTransportResponse - confirms the hold was created. plan is the fresh booking plan for
 * the mission, so the caller can render from it directly instead of refetching.
 *
 * @generated from message booking.v1.PrebookTransportResponse
 */
export type PrebookTransportResponse = Message<"booking.v1.PrebookTransportResponse"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: string mission_id = 2;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.NextAction next_action = 3;
   */
  nextAction?: NextAction;

  /**
   * @generated from field: booking.v1.BookingPlan plan = 4;
   */
  plan?: BookingPlan;
};

/**
 * Describes the message booking.v1.PrebookTransportResponse.
 * Use `create(PrebookTransportResponseSchema)` to create a new message.
 */
export const PrebookTransportResponseSchema: GenMessage<PrebookTransportResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 1);

/**
 * ReleasePrimaryTransportRequest - releases the primary transport hold of a mission.
 *
 * @generated from message booking.v1.ReleasePrimaryTransportRequest
 */
export type ReleasePrimaryTransportRequest = Message<"booking.v1.ReleasePrimaryTransportRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.ReleasePrimaryTransportRequest.
 * Use `create(ReleasePrimaryTransportRequestSchema)` to create a new message.
 */
export const ReleasePrimaryTransportRequestSchema: GenMessage<ReleasePrimaryTransportRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 2);

/**
 * ReleasePrimaryTransportResponse - confirms the primary step is reopened. plan is the fresh
 * booking plan for the mission, so the caller can render from it directly instead of refetching.
 *
 * @generated from message booking.v1.ReleasePrimaryTransportResponse
 */
export type ReleasePrimaryTransportResponse = Message<"booking.v1.ReleasePrimaryTransportResponse"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.NextAction next_action = 2;
   */
  nextAction?: NextAction;

  /**
   * @generated from field: booking.v1.BookingPlan plan = 3;
   */
  plan?: BookingPlan;
};

/**
 * Describes the message booking.v1.ReleasePrimaryTransportResponse.
 * Use `create(ReleasePrimaryTransportResponseSchema)` to create a new message.
 */
export const ReleasePrimaryTransportResponseSchema: GenMessage<ReleasePrimaryTransportResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 3);

/**
 * UpdateRentalVehicleScheduleRequest - the agent-edited rental period; end must be after start.
 *
 * @generated from message booking.v1.UpdateRentalVehicleScheduleRequest
 */
export type UpdateRentalVehicleScheduleRequest = Message<"booking.v1.UpdateRentalVehicleScheduleRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp start = 2;
   */
  start?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end = 3;
   */
  end?: Timestamp;
};

/**
 * Describes the message booking.v1.UpdateRentalVehicleScheduleRequest.
 * Use `create(UpdateRentalVehicleScheduleRequestSchema)` to create a new message.
 */
export const UpdateRentalVehicleScheduleRequestSchema: GenMessage<UpdateRentalVehicleScheduleRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 4);

/**
 * UpdateRentalVehicleScheduleResponse - plan is the fresh booking plan, carrying the repriced rental.
 *
 * @generated from message booking.v1.UpdateRentalVehicleScheduleResponse
 */
export type UpdateRentalVehicleScheduleResponse = Message<"booking.v1.UpdateRentalVehicleScheduleResponse"> & {
  /**
   * @generated from field: booking.v1.BookingPlan plan = 1;
   */
  plan?: BookingPlan;
};

/**
 * Describes the message booking.v1.UpdateRentalVehicleScheduleResponse.
 * Use `create(UpdateRentalVehicleScheduleResponseSchema)` to create a new message.
 */
export const UpdateRentalVehicleScheduleResponseSchema: GenMessage<UpdateRentalVehicleScheduleResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 5);

/**
 * QuoteRentalVehicleExtensionRequest - the new return of a booked rental; it must be after the
 * current one.
 *
 * @generated from message booking.v1.QuoteRentalVehicleExtensionRequest
 */
export type QuoteRentalVehicleExtensionRequest = Message<"booking.v1.QuoteRentalVehicleExtensionRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: google.protobuf.Timestamp new_return_at = 3;
   */
  newReturnAt?: Timestamp;
};

/**
 * Describes the message booking.v1.QuoteRentalVehicleExtensionRequest.
 * Use `create(QuoteRentalVehicleExtensionRequestSchema)` to create a new message.
 */
export const QuoteRentalVehicleExtensionRequestSchema: GenMessage<QuoteRentalVehicleExtensionRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 6);

/**
 * QuoteRentalVehicleExtensionResponse - what the extension costs.
 *
 * @generated from message booking.v1.QuoteRentalVehicleExtensionResponse
 */
export type QuoteRentalVehicleExtensionResponse = Message<"booking.v1.QuoteRentalVehicleExtensionResponse"> & {
  /**
   * @generated from field: booking.v1.RentalVehicleExtensionQuote quote = 1;
   */
  quote?: RentalVehicleExtensionQuote;
};

/**
 * Describes the message booking.v1.QuoteRentalVehicleExtensionResponse.
 * Use `create(QuoteRentalVehicleExtensionResponseSchema)` to create a new message.
 */
export const QuoteRentalVehicleExtensionResponseSchema: GenMessage<QuoteRentalVehicleExtensionResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 7);

/**
 * RentalVehicleExtensionQuote - the cost of pushing back a rental's return. Rentals are billed per
 * started 24h from pickup, so added_days may be 0 when the new return stays in the same 24h.
 *
 * @generated from message booking.v1.RentalVehicleExtensionQuote
 */
export type RentalVehicleExtensionQuote = Message<"booking.v1.RentalVehicleExtensionQuote"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: google.protobuf.Timestamp previous_return_at = 2;
   */
  previousReturnAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp new_return_at = 3;
   */
  newReturnAt?: Timestamp;

  /**
   * @generated from field: int32 added_days = 4;
   */
  addedDays: number;

  /**
   * price spread over added_days, for display.
   *
   * @generated from field: mobility.v1.Price daily_price = 5;
   */
  dailyPrice?: Price;

  /**
   * Extra amount for the added days.
   *
   * @generated from field: mobility.v1.Price price = 6;
   */
  price?: Price;

  /**
   * @generated from field: mobility.v1.Price previous_total_price = 7;
   */
  previousTotalPrice?: Price;

  /**
   * @generated from field: mobility.v1.Price new_total_price = 8;
   */
  newTotalPrice?: Price;
};

/**
 * Describes the message booking.v1.RentalVehicleExtensionQuote.
 * Use `create(RentalVehicleExtensionQuoteSchema)` to create a new message.
 */
export const RentalVehicleExtensionQuoteSchema: GenMessage<RentalVehicleExtensionQuote> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 8);

/**
 * ExtendRentalVehicleRequest - the new return of a booked rental; it must be after the current one.
 *
 * @generated from message booking.v1.ExtendRentalVehicleRequest
 */
export type ExtendRentalVehicleRequest = Message<"booking.v1.ExtendRentalVehicleRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: google.protobuf.Timestamp new_return_at = 3;
   */
  newReturnAt?: Timestamp;
};

/**
 * Describes the message booking.v1.ExtendRentalVehicleRequest.
 * Use `create(ExtendRentalVehicleRequestSchema)` to create a new message.
 */
export const ExtendRentalVehicleRequestSchema: GenMessage<ExtendRentalVehicleRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 9);

/**
 * ExtendRentalVehicleResponse - item is the extended rental, with its new return and price.
 *
 * @generated from message booking.v1.ExtendRentalVehicleResponse
 */
export type ExtendRentalVehicleResponse = Message<"booking.v1.ExtendRentalVehicleResponse"> & {
  /**
   * @generated from field: booking.v1.BookingItem item = 1;
   */
  item?: BookingItem;
};

/**
 * Describes the message booking.v1.ExtendRentalVehicleResponse.
 * Use `create(ExtendRentalVehicleResponseSchema)` to create a new message.
 */
export const ExtendRentalVehicleResponseSchema: GenMessage<ExtendRentalVehicleResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 10);

/**
 * SelectGroundTransferRequest - selects a ground transfer option for a given stage.
 * alternative_id comes from ListGroundTransferAlternativeResponse.
 * Booking order must be respected: PRE_TRANSPORT → BETWEEN_PRIMARY_TRANSPORTS → POST_TRANSPORT according to next_action.ground_transfer_stage.
 *
 * @generated from message booking.v1.SelectGroundTransferRequest
 */
export type SelectGroundTransferRequest = Message<"booking.v1.SelectGroundTransferRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string alternative_id = 2;
   */
  alternativeId: string;

  /**
   * @generated from field: google.protobuf.Timestamp pickup_time = 3;
   */
  pickupTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp min_pickup_time = 4;
   */
  minPickupTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp max_pickup_time = 5;
   */
  maxPickupTime?: Timestamp;

  /**
   * @generated from field: optional string comment = 6;
   */
  comment?: string;
};

/**
 * Describes the message booking.v1.SelectGroundTransferRequest.
 * Use `create(SelectGroundTransferRequestSchema)` to create a new message.
 */
export const SelectGroundTransferRequestSchema: GenMessage<SelectGroundTransferRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 11);

/**
 * SelectGroundTransferResponse - confirms the ground transfer selection. plan is the fresh
 * booking plan for the mission, so the caller can render from it directly instead of refetching.
 *
 * @generated from message booking.v1.SelectGroundTransferResponse
 */
export type SelectGroundTransferResponse = Message<"booking.v1.SelectGroundTransferResponse"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.NextAction next_action = 2;
   */
  nextAction?: NextAction;

  /**
   * @generated from field: booking.v1.BookingPlan plan = 3;
   */
  plan?: BookingPlan;
};

/**
 * Describes the message booking.v1.SelectGroundTransferResponse.
 * Use `create(SelectGroundTransferResponseSchema)` to create a new message.
 */
export const SelectGroundTransferResponseSchema: GenMessage<SelectGroundTransferResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 12);

/**
 * SkipGroundTransferRequest - skips a non-mandatory ground transfer for a given stage.
 *
 * @generated from message booking.v1.SkipGroundTransferRequest
 */
export type SkipGroundTransferRequest = Message<"booking.v1.SkipGroundTransferRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.GroundTransferStage stage = 2;
   */
  stage: GroundTransferStage;
};

/**
 * Describes the message booking.v1.SkipGroundTransferRequest.
 * Use `create(SkipGroundTransferRequestSchema)` to create a new message.
 */
export const SkipGroundTransferRequestSchema: GenMessage<SkipGroundTransferRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 13);

/**
 * SkipGroundTransferResponse - confirms the ground transfer was skipped. plan is the fresh
 * booking plan for the mission, so the caller can render from it directly instead of refetching.
 *
 * @generated from message booking.v1.SkipGroundTransferResponse
 */
export type SkipGroundTransferResponse = Message<"booking.v1.SkipGroundTransferResponse"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.GroundTransferStage stage = 2;
   */
  stage: GroundTransferStage;

  /**
   * @generated from field: booking.v1.NextAction next_action = 3;
   */
  nextAction?: NextAction;

  /**
   * @generated from field: booking.v1.BookingPlan plan = 4;
   */
  plan?: BookingPlan;
};

/**
 * Describes the message booking.v1.SkipGroundTransferResponse.
 * Use `create(SkipGroundTransferResponseSchema)` to create a new message.
 */
export const SkipGroundTransferResponseSchema: GenMessage<SkipGroundTransferResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 14);

/**
 * ConfirmBookingsRequest - triggers firm booking of all prebooked transports for a mission.
 * All ground transfers must be prebooked or skipped before calling this.
 *
 * @generated from message booking.v1.ConfirmBookingsRequest
 */
export type ConfirmBookingsRequest = Message<"booking.v1.ConfirmBookingsRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.ConfirmBookingsRequest.
 * Use `create(ConfirmBookingsRequestSchema)` to create a new message.
 */
export const ConfirmBookingsRequestSchema: GenMessage<ConfirmBookingsRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 15);

/**
 * ConfirmBookingsResponse - acknowledges that confirmation was triggered.
 * Use StreamConfirmationStatus to follow individual booking outcomes in real time.
 *
 * @generated from message booking.v1.ConfirmBookingsResponse
 */
export type ConfirmBookingsResponse = Message<"booking.v1.ConfirmBookingsResponse"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.ConfirmBookingsResponse.
 * Use `create(ConfirmBookingsResponseSchema)` to create a new message.
 */
export const ConfirmBookingsResponseSchema: GenMessage<ConfirmBookingsResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 16);

/**
 * CreateRefundRequest - requests a refund quote for a booked item, or for every booked item on
 * the mission when item_id is unset.
 *
 * @generated from message booking.v1.CreateRefundRequest
 */
export type CreateRefundRequest = Message<"booking.v1.CreateRefundRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * If unset, every booked item on the mission is quoted for refund.
   *
   * @generated from field: optional string item_id = 2;
   */
  itemId?: string;

  /**
   * Narrows the refund to specific segments/passengers of a train item. Only meaningful when
   * item_id targets a train item; ignored otherwise. If unset, the whole item is refunded.
   *
   * @generated from field: optional booking.v1.TrainRefundParams train_params = 3;
   */
  trainParams?: TrainRefundParams;
};

/**
 * Describes the message booking.v1.CreateRefundRequest.
 * Use `create(CreateRefundRequestSchema)` to create a new message.
 */
export const CreateRefundRequestSchema: GenMessage<CreateRefundRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 17);

/**
 * TrainRefundParams - narrows a train item's refund to specific segments and/or passengers.
 *
 * @generated from message booking.v1.TrainRefundParams
 */
export type TrainRefundParams = Message<"booking.v1.TrainRefundParams"> & {
  /**
   * @generated from field: repeated string segment_ids = 1;
   */
  segmentIds: string[];

  /**
   * @generated from field: repeated string passenger_ids = 2;
   */
  passengerIds: string[];
};

/**
 * Describes the message booking.v1.TrainRefundParams.
 * Use `create(TrainRefundParamsSchema)` to create a new message.
 */
export const TrainRefundParamsSchema: GenMessage<TrainRefundParams> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 18);

/**
 * CreateRefundResponse - the refund quote(s) requested: a single entry when item_id was set,
 * one entry per booked item otherwise. Nothing is performed on the provider side yet; call
 * ValidateRefund to confirm each quote.
 *
 * @generated from message booking.v1.CreateRefundResponse
 */
export type CreateRefundResponse = Message<"booking.v1.CreateRefundResponse"> & {
  /**
   * @generated from field: repeated booking.v1.Refund refunds = 1;
   */
  refunds: Refund[];
};

/**
 * Describes the message booking.v1.CreateRefundResponse.
 * Use `create(CreateRefundResponseSchema)` to create a new message.
 */
export const CreateRefundResponseSchema: GenMessage<CreateRefundResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 19);

/**
 * ValidateRefundRequest - confirms the pending refund quote for a booked item.
 *
 * @generated from message booking.v1.ValidateRefundRequest
 */
export type ValidateRefundRequest = Message<"booking.v1.ValidateRefundRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * refund_id values as returned by CreateRefund. Confirmed in order, stopping at the first
   * failure.
   *
   * @generated from field: repeated string refund_ids = 2;
   */
  refundIds: string[];
};

/**
 * Describes the message booking.v1.ValidateRefundRequest.
 * Use `create(ValidateRefundRequestSchema)` to create a new message.
 */
export const ValidateRefundRequestSchema: GenMessage<ValidateRefundRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 20);

/**
 * ValidateRefundResponse - the refunds after confirmation, in the order refund_ids was given.
 *
 * @generated from message booking.v1.ValidateRefundResponse
 */
export type ValidateRefundResponse = Message<"booking.v1.ValidateRefundResponse"> & {
  /**
   * @generated from field: repeated booking.v1.Refund refunds = 1;
   */
  refunds: Refund[];
};

/**
 * Describes the message booking.v1.ValidateRefundResponse.
 * Use `create(ValidateRefundResponseSchema)` to create a new message.
 */
export const ValidateRefundResponseSchema: GenMessage<ValidateRefundResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 21);

/**
 * CancelRefundRequest - discards the pending refund quote for a booked item, without performing
 * anything on the provider side.
 *
 * @generated from message booking.v1.CancelRefundRequest
 */
export type CancelRefundRequest = Message<"booking.v1.CancelRefundRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * refund_id values as returned by CreateRefund. Discarded in order, stopping at the first
   * failure.
   *
   * @generated from field: repeated string refund_ids = 2;
   */
  refundIds: string[];
};

/**
 * Describes the message booking.v1.CancelRefundRequest.
 * Use `create(CancelRefundRequestSchema)` to create a new message.
 */
export const CancelRefundRequestSchema: GenMessage<CancelRefundRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 22);

/**
 * CancelRefundResponse - the refunds after being discarded, in the order refund_ids was given.
 *
 * @generated from message booking.v1.CancelRefundResponse
 */
export type CancelRefundResponse = Message<"booking.v1.CancelRefundResponse"> & {
  /**
   * @generated from field: repeated booking.v1.Refund refunds = 1;
   */
  refunds: Refund[];
};

/**
 * Describes the message booking.v1.CancelRefundResponse.
 * Use `create(CancelRefundResponseSchema)` to create a new message.
 */
export const CancelRefundResponseSchema: GenMessage<CancelRefundResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 23);

/**
 * Refund - a refund quote or outcome for a single booked item.
 *
 * @generated from message booking.v1.Refund
 */
export type Refund = Message<"booking.v1.Refund"> & {
  /**
   * @generated from field: string refund_id = 1;
   */
  refundId: string;

  /**
   * @generated from field: booking.v1.RefundStatus status = 2;
   */
  status: RefundStatus;

  /**
   * @generated from field: mobility.v1.Price initial_price = 3;
   */
  initialPrice?: Price;

  /**
   * @generated from field: mobility.v1.Price refund_price = 4;
   */
  refundPrice?: Price;

  /**
   * @generated from field: mobility.v1.Price fees = 5;
   */
  fees?: Price;

  /**
   * @generated from field: repeated booking.v1.RefundedTicket refunded_tickets = 6;
   */
  refundedTickets: RefundedTicket[];

  /**
   * The item this refund applies to.
   *
   * @generated from field: string item_id = 7;
   */
  itemId: string;
};

/**
 * Describes the message booking.v1.Refund.
 * Use `create(RefundSchema)` to create a new message.
 */
export const RefundSchema: GenMessage<Refund> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 24);

/**
 * RefundedTicket - the refund detail for a single ticket within a refunded item (train items may
 * carry several).
 *
 * @generated from message booking.v1.RefundedTicket
 */
export type RefundedTicket = Message<"booking.v1.RefundedTicket"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * @generated from field: mobility.v1.Price initial_price = 2;
   */
  initialPrice?: Price;

  /**
   * @generated from field: mobility.v1.Price refund_price = 3;
   */
  refundPrice?: Price;

  /**
   * @generated from field: mobility.v1.Price fees = 4;
   */
  fees?: Price;
};

/**
 * Describes the message booking.v1.RefundedTicket.
 * Use `create(RefundedTicketSchema)` to create a new message.
 */
export const RefundedTicketSchema: GenMessage<RefundedTicket> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 25);

/**
 * ListMissionBookingsRequest - lists all booking summaries for a mission.
 *
 * @generated from message booking.v1.ListMissionBookingsRequest
 */
export type ListMissionBookingsRequest = Message<"booking.v1.ListMissionBookingsRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.ListMissionBookingsRequest.
 * Use `create(ListMissionBookingsRequestSchema)` to create a new message.
 */
export const ListMissionBookingsRequestSchema: GenMessage<ListMissionBookingsRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 26);

/**
 * ListMissionBookingsResponse - the booking aggregate (with all items) for a mission.
 *
 * @generated from message booking.v1.ListMissionBookingsResponse
 */
export type ListMissionBookingsResponse = Message<"booking.v1.ListMissionBookingsResponse"> & {
  /**
   * @generated from field: booking.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message booking.v1.ListMissionBookingsResponse.
 * Use `create(ListMissionBookingsResponseSchema)` to create a new message.
 */
export const ListMissionBookingsResponseSchema: GenMessage<ListMissionBookingsResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 27);

/**
 * ListBookingsRequest - request for listing bookings across missions, with pagination.
 *
 * @generated from message booking.v1.ListBookingsRequest
 */
export type ListBookingsRequest = Message<"booking.v1.ListBookingsRequest"> & {
  /**
   * @generated from field: string page_cursor = 1;
   */
  pageCursor: string;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message booking.v1.ListBookingsRequest.
 * Use `create(ListBookingsRequestSchema)` to create a new message.
 */
export const ListBookingsRequestSchema: GenMessage<ListBookingsRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 28);

/**
 * ListBookingsResponse - paginated list of booking summaries across missions, newest first.
 *
 * @generated from message booking.v1.ListBookingsResponse
 */
export type ListBookingsResponse = Message<"booking.v1.ListBookingsResponse"> & {
  /**
   * @generated from field: repeated booking.v1.BookingSummary items = 1;
   */
  items: BookingSummary[];

  /**
   * @generated from field: string next_page_cursor = 2;
   */
  nextPageCursor: string;
};

/**
 * Describes the message booking.v1.ListBookingsResponse.
 * Use `create(ListBookingsResponseSchema)` to create a new message.
 */
export const ListBookingsResponseSchema: GenMessage<ListBookingsResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 29);

/**
 * BookingSummary - one row of the admin bookings list: identifying and status info for a mission's
 * booking, without the full item breakdown (see Booking for that).
 *
 * @generated from message booking.v1.BookingSummary
 */
export type BookingSummary = Message<"booking.v1.BookingSummary"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * @generated from field: booking.v1.BookingStatus status = 4;
   */
  status: BookingStatus;

  /**
   * @generated from field: mobility.v1.TransportType transport_type = 5;
   */
  transportType: TransportType;

  /**
   * @generated from field: string beneficiary_first_name = 6;
   */
  beneficiaryFirstName: string;

  /**
   * @generated from field: string beneficiary_last_name = 7;
   */
  beneficiaryLastName: string;

  /**
   * @generated from field: google.protobuf.Timestamp chosen_at = 8;
   */
  chosenAt?: Timestamp;

  /**
   * Case (dossier) number, e.g. for display next to the beneficiary name. Rows sharing the same
   * case_id are grouped by the frontend into one dossier with a row per mission.
   *
   * @generated from field: string case_number = 9;
   */
  caseNumber: string;

  /**
   * Optional contract reference for the case; empty when not set.
   *
   * @generated from field: string contract_id = 10;
   */
  contractId: string;

  /**
   * @generated from field: google.protobuf.Timestamp case_created_at = 11;
   */
  caseCreatedAt?: Timestamp;
};

/**
 * Describes the message booking.v1.BookingSummary.
 * Use `create(BookingSummarySchema)` to create a new message.
 */
export const BookingSummarySchema: GenMessage<BookingSummary> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 30);

/**
 * GetBookingCoreRequest - request for the raw booking core JSON of a mission.
 *
 * @generated from message booking.v1.GetBookingCoreRequest
 */
export type GetBookingCoreRequest = Message<"booking.v1.GetBookingCoreRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.GetBookingCoreRequest.
 * Use `create(GetBookingCoreRequestSchema)` to create a new message.
 */
export const GetBookingCoreRequestSchema: GenMessage<GetBookingCoreRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 31);

/**
 * GetBookingCoreResponse - the mission's booking core, as persisted, serialized to JSON, plus the
 * journey computed from it (segments, placeholders, wait times) for debugging.
 *
 * @generated from message booking.v1.GetBookingCoreResponse
 */
export type GetBookingCoreResponse = Message<"booking.v1.GetBookingCoreResponse"> & {
  /**
   * @generated from field: string core_json = 1;
   */
  coreJson: string;

  /**
   * @generated from field: string journey_json = 2;
   */
  journeyJson: string;
};

/**
 * Describes the message booking.v1.GetBookingCoreResponse.
 * Use `create(GetBookingCoreResponseSchema)` to create a new message.
 */
export const GetBookingCoreResponseSchema: GenMessage<GetBookingCoreResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 32);

/**
 * ChosenSolution - snapshot of the mobility solution the user picked at search time, persisted at ChooseSolution.
 *
 * @generated from message booking.v1.ChosenSolution
 */
export type ChosenSolution = Message<"booking.v1.ChosenSolution"> & {
  /**
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;

  /**
   * @generated from field: bool is_multimodal = 2;
   */
  isMultimodal: boolean;

  /**
   * @generated from field: repeated booking.v1.SelectedPrimaryTransport primary_transports = 3;
   */
  primaryTransports: SelectedPrimaryTransport[];
};

/**
 * Describes the message booking.v1.ChosenSolution.
 * Use `create(ChosenSolutionSchema)` to create a new message.
 */
export const ChosenSolutionSchema: GenMessage<ChosenSolution> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 33);

/**
 * SelectedPrimaryTransport - a primary leg the user picked, with the rich booking-shaped details
 * snapshotted at ChooseSolution time.
 *
 * @generated from message booking.v1.SelectedPrimaryTransport
 */
export type SelectedPrimaryTransport = Message<"booking.v1.SelectedPrimaryTransport"> & {
  /**
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from oneof booking.v1.SelectedPrimaryTransport.details
   */
  details: {
    /**
     * @generated from field: booking.v1.TrainBooking train = 2;
     */
    value: TrainBooking;
    case: "train";
  } | {
    /**
     * @generated from field: booking.v1.TaxiBooking taxi = 3;
     */
    value: TaxiBooking;
    case: "taxi";
  } | {
    /**
     * @generated from field: booking.v1.RentalVehicleBooking rental_vehicle = 4;
     */
    value: RentalVehicleBooking;
    case: "rentalVehicle";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message booking.v1.SelectedPrimaryTransport.
 * Use `create(SelectedPrimaryTransportSchema)` to create a new message.
 */
export const SelectedPrimaryTransportSchema: GenMessage<SelectedPrimaryTransport> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 34);

/**
 * StreamConfirmationStatusRequest - initiates streaming until all bookings reach a terminal status.
 *
 * @generated from message booking.v1.StreamConfirmationStatusRequest
 */
export type StreamConfirmationStatusRequest = Message<"booking.v1.StreamConfirmationStatusRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.StreamConfirmationStatusRequest.
 * Use `create(StreamConfirmationStatusRequestSchema)` to create a new message.
 */
export const StreamConfirmationStatusRequestSchema: GenMessage<StreamConfirmationStatusRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 35);

/**
 * StreamConfirmationStatusResponse - streamed event: initial snapshot then per-item deltas.
 *
 * @generated from message booking.v1.StreamConfirmationStatusResponse
 */
export type StreamConfirmationStatusResponse = Message<"booking.v1.StreamConfirmationStatusResponse"> & {
  /**
   * @generated from oneof booking.v1.StreamConfirmationStatusResponse.event
   */
  event: {
    /**
     * @generated from field: booking.v1.ConfirmationStatusSnapshot snapshot = 1;
     */
    value: ConfirmationStatusSnapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: booking.v1.BookingItemUpdate item_update = 2;
     */
    value: BookingItemUpdate;
    case: "itemUpdate";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message booking.v1.StreamConfirmationStatusResponse.
 * Use `create(StreamConfirmationStatusResponseSchema)` to create a new message.
 */
export const StreamConfirmationStatusResponseSchema: GenMessage<StreamConfirmationStatusResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 36);

/**
 * BookingItemUpdate - streaming event carrying the updated state of a single booking item.
 *
 * @generated from message booking.v1.BookingItemUpdate
 */
export type BookingItemUpdate = Message<"booking.v1.BookingItemUpdate"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: booking.v1.BookingItem item = 2;
   */
  item?: BookingItem;
};

/**
 * Describes the message booking.v1.BookingItemUpdate.
 * Use `create(BookingItemUpdateSchema)` to create a new message.
 */
export const BookingItemUpdateSchema: GenMessage<BookingItemUpdate> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 37);

/**
 * ConfirmationStatusSnapshot - full snapshot of the mission's booking aggregate.
 *
 * @generated from message booking.v1.ConfirmationStatusSnapshot
 */
export type ConfirmationStatusSnapshot = Message<"booking.v1.ConfirmationStatusSnapshot"> & {
  /**
   * @generated from field: booking.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message booking.v1.ConfirmationStatusSnapshot.
 * Use `create(ConfirmationStatusSnapshotSchema)` to create a new message.
 */
export const ConfirmationStatusSnapshotSchema: GenMessage<ConfirmationStatusSnapshot> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 38);

/**
 * Booking - aggregate representing all reservations attached to a Mission.
 * A Booking is monomodal when it contains a single item (one primary transport, no ground transfer)
 * or multimodal when it contains a primary transport plus ground transfer items.
 * A Booking is created up-front at ChooseSolution and is the single root tracked through the flow.
 *
 * `status` is the aggregated lifecycle state derived from items:
 *   - CONFIRMED  iff every non-skipped item is CONFIRMED
 *   - ERROR      if any item is in ERROR
 *   - CANCELED   if any item is CANCELED and none are in ERROR
 *   - PREBOOKED  if every primary item is at least PREBOOKED and no terminal failure
 *   - PENDING    otherwise (initial / partial progress)
 *
 * @generated from message booking.v1.Booking
 */
export type Booking = Message<"booking.v1.Booking"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: booking.v1.BookingStatus status = 2;
   */
  status: BookingStatus;

  /**
   * @generated from field: repeated booking.v1.BookingItem items = 3;
   */
  items: BookingItem[];
};

/**
 * Describes the message booking.v1.Booking.
 * Use `create(BookingSchema)` to create a new message.
 */
export const BookingSchema: GenMessage<Booking> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 39);

/**
 * BookingItem - atomic unit of a Booking. Uniform across primary transports and ground transfers.
 * The `kind` oneof discriminates primary vs ground transfer (carrying the stage in the latter case).
 * The `transport` oneof carries the transport-specific data.
 *
 * @generated from message booking.v1.BookingItem
 */
export type BookingItem = Message<"booking.v1.BookingItem"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: booking.v1.BookingStatus status = 2;
   */
  status: BookingStatus;

  /**
   * @generated from oneof booking.v1.BookingItem.kind
   */
  kind: {
    /**
     * @generated from field: booking.v1.PrimaryItem primary = 3;
     */
    value: PrimaryItem;
    case: "primary";
  } | {
    /**
     * @generated from field: booking.v1.GroundTransferItem ground_transfer = 4;
     */
    value: GroundTransferItem;
    case: "groundTransfer";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from oneof booking.v1.BookingItem.transport
   */
  transport: {
    /**
     * @generated from field: booking.v1.TrainBooking train = 5;
     */
    value: TrainBooking;
    case: "train";
  } | {
    /**
     * @generated from field: booking.v1.TaxiBooking taxi = 6;
     */
    value: TaxiBooking;
    case: "taxi";
  } | {
    /**
     * @generated from field: booking.v1.RentalVehicleBooking rental_vehicle = 7;
     */
    value: RentalVehicleBooking;
    case: "rentalVehicle";
  } | { case: undefined; value?: undefined };

  /**
   * Why the last confirm attempt failed. Set only when status is ERROR.
   *
   * @generated from field: booking.v1.BookingItemFailureReason failure_reason = 8;
   */
  failureReason: BookingItemFailureReason;
};

/**
 * Describes the message booking.v1.BookingItem.
 * Use `create(BookingItemSchema)` to create a new message.
 */
export const BookingItemSchema: GenMessage<BookingItem> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 40);

/**
 * PrimaryItem - marker indicating the item is for a primary transport leg.
 *
 * @generated from message booking.v1.PrimaryItem
 */
export type PrimaryItem = Message<"booking.v1.PrimaryItem"> & {
};

/**
 * Describes the message booking.v1.PrimaryItem.
 * Use `create(PrimaryItemSchema)` to create a new message.
 */
export const PrimaryItemSchema: GenMessage<PrimaryItem> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 41);

/**
 * GroundTransferItem - marker indicating the item is for a ground transfer slot, carrying the slot's stage.
 *
 * @generated from message booking.v1.GroundTransferItem
 */
export type GroundTransferItem = Message<"booking.v1.GroundTransferItem"> & {
  /**
   * @generated from field: booking.v1.GroundTransferStage stage = 1;
   */
  stage: GroundTransferStage;

  /**
   * Localized label for the navigation button (e.g. "Pre-transport transfer").
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: booking.v1.GroundTransferDecision decision = 3;
   */
  decision: GroundTransferDecision;

  /**
   * How the selected option is reserved. CALLBACK = manual coordination (not bookable online).
   *
   * @generated from field: booking.v1.GroundTransferBookingMode booking_mode = 4;
   */
  bookingMode: GroundTransferBookingMode;
};

/**
 * Describes the message booking.v1.GroundTransferItem.
 * Use `create(GroundTransferItemSchema)` to create a new message.
 */
export const GroundTransferItemSchema: GenMessage<GroundTransferItem> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 42);

/**
 * ListGroundTransferAlternativesRequest - lists available ground transfer options for a stage.
 *
 * @generated from message booking.v1.ListGroundTransferAlternativesRequest
 */
export type ListGroundTransferAlternativesRequest = Message<"booking.v1.ListGroundTransferAlternativesRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.GroundTransferStage stage = 2;
   */
  stage: GroundTransferStage;
};

/**
 * Describes the message booking.v1.ListGroundTransferAlternativesRequest.
 * Use `create(ListGroundTransferAlternativesRequestSchema)` to create a new message.
 */
export const ListGroundTransferAlternativesRequestSchema: GenMessage<ListGroundTransferAlternativesRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 43);

/**
 * ListGroundTransferAlternativesResponse - available ground transfer options for the requested stage.
 *
 * @generated from message booking.v1.ListGroundTransferAlternativesResponse
 */
export type ListGroundTransferAlternativesResponse = Message<"booking.v1.ListGroundTransferAlternativesResponse"> & {
  /**
   * @generated from field: repeated booking.v1.GroundTransferAlternative alternatives = 1;
   */
  alternatives: GroundTransferAlternative[];

  /**
   * The primary transport this stage connects to: schedule + places, for the departure/arrival
   * display. Unset when the journey has no adjacent primary transport.
   *
   * @generated from field: mobility.v1.TransportLeg linked_transport = 2;
   */
  linkedTransport?: TransportLeg;

  /**
   * How the stage can be resolved: pick an online alternative, or call the assister back.
   *
   * @generated from field: booking.v1.GroundTransferBookingMode booking_mode = 3;
   */
  bookingMode: GroundTransferBookingMode;

  /**
   * Recalled passenger count from the search form.
   *
   * @generated from field: int32 passengers_count = 4;
   */
  passengersCount: number;
};

/**
 * Describes the message booking.v1.ListGroundTransferAlternativesResponse.
 * Use `create(ListGroundTransferAlternativesResponseSchema)` to create a new message.
 */
export const ListGroundTransferAlternativesResponseSchema: GenMessage<ListGroundTransferAlternativesResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 44);

/**
 * GroundTransferAlternative - one selectable ground transfer option for a stage.
 *
 * @generated from message booking.v1.GroundTransferAlternative
 */
export type GroundTransferAlternative = Message<"booking.v1.GroundTransferAlternative"> & {
  /**
   * @generated from field: string alternative_id = 1;
   */
  alternativeId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string company_name = 3;
   */
  companyName: string;

  /**
   * @generated from field: string company_logo = 4;
   */
  companyLogo: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: int32 max_passenger_capacity = 6;
   */
  maxPassengerCapacity: number;

  /**
   * @generated from field: mobility.v1.Price estimated_price = 7;
   */
  estimatedPrice?: Price;

  /**
   * Leg from the pickup point to the drop-off point (start_place / end_place / start_at / end_at).
   *
   * @generated from field: mobility.v1.TransportLeg leg = 8;
   */
  leg?: TransportLeg;

  /**
   * Suggested pickup time derived from the primary transport schedule.
   *
   * @generated from field: google.protobuf.Timestamp reference_pickup_time = 9;
   */
  referencePickupTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp min_pickup_time = 10;
   */
  minPickupTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp max_pickup_time = 11;
   */
  maxPickupTime?: Timestamp;

  /**
   * @generated from field: optional mobility.v1.TransportAgency agency = 12;
   */
  agency?: TransportAgency;

  /**
   * @generated from field: optional mobility.v1.CO2Emission co2_emission = 13;
   */
  co2Emission?: CO2Emission;

  /**
   * @generated from field: optional mobility.v1.Flags flags = 14;
   */
  flags?: Flags;

  /**
   * Distinguishes e.g. a chauffeured transfer (agency-driven, bundled with the rental) from a
   * regular taxi -- both can otherwise carry the same shape (label, agency, no price).
   *
   * @generated from field: mobility.v1.TransportType transport_type = 15;
   */
  transportType: TransportType;

  /**
   * True when the ride duration/distance came from a live/traffic-aware routing source, rather
   * than the provider's own static pricing table.
   *
   * @generated from field: bool is_live_traffic = 16;
   */
  isLiveTraffic: boolean;

  /**
   * Set for a walk alternative: the routed walking distance.
   *
   * @generated from field: optional int64 distance_in_meters = 17;
   */
  distanceInMeters?: bigint;

  /**
   * True for the alternative matching the offer already selected for this stage, re-quoted.
   *
   * @generated from field: bool is_current_choice = 18;
   */
  isCurrentChoice: boolean;
};

/**
 * Describes the message booking.v1.GroundTransferAlternative.
 * Use `create(GroundTransferAlternativeSchema)` to create a new message.
 */
export const GroundTransferAlternativeSchema: GenMessage<GroundTransferAlternative> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 45);

/**
 * GroundTransferSlot - state of a ground transfer slot within a mission (resolved or pending).
 *
 * @generated from message booking.v1.GroundTransferSlot
 */
export type GroundTransferSlot = Message<"booking.v1.GroundTransferSlot"> & {
  /**
   * @generated from field: booking.v1.GroundTransferStage stage = 1;
   */
  stage: GroundTransferStage;

  /**
   * Localized label for the navigation button (e.g. "Pre-transport transfer").
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: booking.v1.GroundTransferDecision decision = 3;
   */
  decision: GroundTransferDecision;

  /**
   * How the selected option is reserved. CALLBACK = manual coordination (not bookable online).
   *
   * @generated from field: booking.v1.GroundTransferBookingMode booking_mode = 4;
   */
  bookingMode: GroundTransferBookingMode;
};

/**
 * Describes the message booking.v1.GroundTransferSlot.
 * Use `create(GroundTransferSlotSchema)` to create a new message.
 */
export const GroundTransferSlotSchema: GenMessage<GroundTransferSlot> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 46);

/**
 * NextAction - server-driven indication of the next step in the booking flow.
 * Returned by every mutation that advances the flow (Prebook, Select, Skip).
 *
 * @generated from message booking.v1.NextAction
 */
export type NextAction = Message<"booking.v1.NextAction"> & {
  /**
   * @generated from field: booking.v1.NextActionStep step = 1;
   */
  step: NextActionStep;

  /**
   * Set when step == NEXT_ACTION_STEP_PREBOOK_PRIMARY_TRANSPORT.
   *
   * @generated from field: optional mission.v1.PrimaryTransportRef primary_transport = 2;
   */
  primaryTransport?: PrimaryTransportRef;

  /**
   * Set when step == NEXT_ACTION_STEP_SELECT_OR_SKIP_GROUND_TRANSFER.
   *
   * @generated from field: optional booking.v1.GroundTransferStage ground_transfer_stage = 3;
   */
  groundTransferStage?: GroundTransferStage;

  /**
   * Ground transfer slots for which a decision has already been made.
   *
   * @generated from field: repeated booking.v1.GroundTransferSlot resolved_ground_transfers = 4;
   */
  resolvedGroundTransfers: GroundTransferSlot[];

  /**
   * Traveller details recalled from the search form to prefill the step's prebook form. Populated by
   * GetNextAction for a prebook/ground-transfer step; absent on mutation acks and at confirm time.
   *
   * @generated from field: optional booking.v1.PrebookContext prebook_context = 5;
   */
  prebookContext?: PrebookContext;

  /**
   * TTL expiry of the held primary transport (train only; other transports have no hold TTL).
   * Set once the primary transport is prebooked, until the mission is confirmed.
   *
   * @generated from field: optional google.protobuf.Timestamp primary_transport_expires_at = 6;
   */
  primaryTransportExpiresAt?: Timestamp;

  /**
   * Every ground transfer slot of the mission, whatever its decision, ordered by stage.
   *
   * @generated from field: repeated booking.v1.GroundTransferSlot ground_transfers = 7;
   */
  groundTransfers: GroundTransferSlot[];

  /**
   * Set by GetNextAction while the primary transport is held by the provider (train) and the mission
   * is not being confirmed: steps before the prebook render read-only until the hold is released.
   *
   * @generated from field: optional booking.v1.HeldPrimary held_primary = 8;
   */
  heldPrimary?: HeldPrimary;
};

/**
 * Describes the message booking.v1.NextAction.
 * Use `create(NextActionSchema)` to create a new message.
 */
export const NextActionSchema: GenMessage<NextAction> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 47);

/**
 * HeldPrimary - the primary transport hold, and what a page before the prebook step needs to show
 * it and send the traveller back into the flow.
 *
 * @generated from message booking.v1.HeldPrimary
 */
export type HeldPrimary = Message<"booking.v1.HeldPrimary"> & {
  /**
   * Unset when the provider gave the hold no TTL.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 1;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: string search_id = 2;
   */
  searchId: string;

  /**
   * @generated from field: string mobility_solution_id = 3;
   */
  mobilitySolutionId: string;

  /**
   * @generated from field: string booking_id = 4;
   */
  bookingId: string;

  /**
   * Prebook form context of the held transport, to render the form read-only.
   *
   * @generated from field: booking.v1.PrebookContext prebook_context = 5;
   */
  prebookContext?: PrebookContext;
};

/**
 * Describes the message booking.v1.HeldPrimary.
 * Use `create(HeldPrimarySchema)` to create a new message.
 */
export const HeldPrimarySchema: GenMessage<HeldPrimary> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 48);

/**
 * GetPlanRequest - request for the booking plan of a Mission.
 *
 * @generated from message booking.v1.GetPlanRequest
 */
export type GetPlanRequest = Message<"booking.v1.GetPlanRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.GetPlanRequest.
 * Use `create(GetPlanRequestSchema)` to create a new message.
 */
export const GetPlanRequestSchema: GenMessage<GetPlanRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 49);

/**
 * GetPlanResponse - response containing the booking plan for a Mission.
 *
 * @generated from message booking.v1.GetPlanResponse
 */
export type GetPlanResponse = Message<"booking.v1.GetPlanResponse"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: booking.v1.BookingPlan booking_plan = 2;
   */
  bookingPlan?: BookingPlan;
};

/**
 * Describes the message booking.v1.GetPlanResponse.
 * Use `create(GetPlanResponseSchema)` to create a new message.
 */
export const GetPlanResponseSchema: GenMessage<GetPlanResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 50);

/**
 * BookingPlan - the booking plan for a Mission, including the current state of all bookings and ancillary selections.
 *
 * @generated from message booking.v1.BookingPlan
 */
export type BookingPlan = Message<"booking.v1.BookingPlan"> & {
  /**
   * @generated from field: repeated booking.v1.BookingPlanEntry entries = 1;
   */
  entries: BookingPlanEntry[];

  /**
   * @generated from field: mobility.v1.Price total_price = 2;
   */
  totalPrice?: Price;
};

/**
 * Describes the message booking.v1.BookingPlan.
 * Use `create(BookingPlanSchema)` to create a new message.
 */
export const BookingPlanSchema: GenMessage<BookingPlan> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 51);

/**
 * BookingPlanEntry - an entry in the booking plan, representing either a primary transport or a ground transfer, along with its current booking status and transport-specific details.
 *
 * @generated from message booking.v1.BookingPlanEntry
 */
export type BookingPlanEntry = Message<"booking.v1.BookingPlanEntry"> & {
  /**
   * @generated from field: optional booking.v1.BookingStatus status = 1;
   */
  status?: BookingStatus;

  /**
   * @generated from oneof booking.v1.BookingPlanEntry.kind
   */
  kind: {
    /**
     * @generated from field: booking.v1.PrimaryItem primary = 2;
     */
    value: PrimaryItem;
    case: "primary";
  } | {
    /**
     * @generated from field: booking.v1.GroundTransferItem ground_transfer = 3;
     */
    value: GroundTransferItem;
    case: "groundTransfer";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: mobility.v1.TransportType transport_type = 4;
   */
  transportType: TransportType;

  /**
   * @generated from field: mobility.v1.Fare fare = 5;
   */
  fare?: Fare;

  /**
   * @generated from field: mobility.v1.Price price = 6;
   */
  price?: Price;
};

/**
 * Describes the message booking.v1.BookingPlanEntry.
 * Use `create(BookingPlanEntrySchema)` to create a new message.
 */
export const BookingPlanEntrySchema: GenMessage<BookingPlanEntry> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 52);

/**
 * GetNextActionRequest - request for the current next action of a mission.
 *
 * @generated from message booking.v1.GetNextActionRequest
 */
export type GetNextActionRequest = Message<"booking.v1.GetNextActionRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message booking.v1.GetNextActionRequest.
 * Use `create(GetNextActionRequestSchema)` to create a new message.
 */
export const GetNextActionRequestSchema: GenMessage<GetNextActionRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 53);

/**
 * GetNextActionResponse - the current next action, enriched with the prebook context for the step.
 *
 * @generated from message booking.v1.GetNextActionResponse
 */
export type GetNextActionResponse = Message<"booking.v1.GetNextActionResponse"> & {
  /**
   * @generated from field: booking.v1.NextAction next_action = 1;
   */
  nextAction?: NextAction;
};

/**
 * Describes the message booking.v1.GetNextActionResponse.
 * Use `create(GetNextActionResponseSchema)` to create a new message.
 */
export const GetNextActionResponseSchema: GenMessage<GetNextActionResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 54);

/**
 * GetSeatMapRequest - request for a train segment's seatmap payload.
 *
 * @generated from message booking.v1.GetSeatMapRequest
 */
export type GetSeatMapRequest = Message<"booking.v1.GetSeatMapRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string segment_id = 2;
   */
  segmentId: string;
};

/**
 * Describes the message booking.v1.GetSeatMapRequest.
 * Use `create(GetSeatMapRequestSchema)` to create a new message.
 */
export const GetSeatMapRequestSchema: GenMessage<GetSeatMapRequest> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 55);

/**
 * GetSeatMapResponse - the provider's raw seatmap payload for the requested segment.
 *
 * @generated from message booking.v1.GetSeatMapResponse
 */
export type GetSeatMapResponse = Message<"booking.v1.GetSeatMapResponse"> & {
  /**
   * Raw JSON, passed as-is to the `data` prop of the pao-seatmap-ui web component.
   *
   * @generated from field: string seat_map_json = 1;
   */
  seatMapJson: string;
};

/**
 * Describes the message booking.v1.GetSeatMapResponse.
 * Use `create(GetSeatMapResponseSchema)` to create a new message.
 */
export const GetSeatMapResponseSchema: GenMessage<GetSeatMapResponse> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 56);

/**
 * PrebookContext - read model backing the prebook form for one primary transport: the chosen-leg
 * summary (header) plus, by mode, the traveller values recalled from the search form and the chosen
 * offer. The per-mode fields each expose exactly what the matching prebook request consumes
 * (TrainPrebook, RentalVehiclePrebook); see those for which are mandatory at prebook time.
 *
 * @generated from message booking.v1.PrebookContext
 */
export type PrebookContext = Message<"booking.v1.PrebookContext"> & {
  /**
   * Header of the chosen leg ("Trajet principal"): transport, places + schedule, CO2.
   *
   * @generated from field: booking.v1.PrebookSummary summary = 1;
   */
  summary?: PrebookSummary;

  /**
   * @generated from oneof booking.v1.PrebookContext.mode
   */
  mode: {
    /**
     * @generated from field: booking.v1.TrainPrebookContext train = 2;
     */
    value: TrainPrebookContext;
    case: "train";
  } | {
    /**
     * @generated from field: booking.v1.TaxiPrebookContext taxi = 3;
     */
    value: TaxiPrebookContext;
    case: "taxi";
  } | {
    /**
     * @generated from field: booking.v1.RentalVehiclePrebookContext rental_vehicle = 4;
     */
    value: RentalVehiclePrebookContext;
    case: "rentalVehicle";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message booking.v1.PrebookContext.
 * Use `create(PrebookContextSchema)` to create a new message.
 */
export const PrebookContextSchema: GenMessage<PrebookContext> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 57);

/**
 * PrebookSummary - generic header of the chosen leg, common to every mode. Built from the chosen
 * solution (before any prebook).
 *
 * @generated from message booking.v1.PrebookSummary
 */
export type PrebookSummary = Message<"booking.v1.PrebookSummary"> & {
  /**
   * mode + label + logo
   *
   * @generated from field: mobility.v1.Transport transport = 1;
   */
  transport?: Transport;

  /**
   * departure/arrival places + times
   *
   * @generated from field: mobility.v1.TransportLeg leg = 2;
   */
  leg?: TransportLeg;

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 3;
   */
  co2Emission?: CO2Emission;
};

/**
 * Describes the message booking.v1.PrebookSummary.
 * Use `create(PrebookSummarySchema)` to create a new message.
 */
export const PrebookSummarySchema: GenMessage<PrebookSummary> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 58);

/**
 * TrainPrebookContext - recalled train passengers, the chosen-journey segments and selected fare.
 *
 * @generated from message booking.v1.TrainPrebookContext
 */
export type TrainPrebookContext = Message<"booking.v1.TrainPrebookContext"> & {
  /**
   * Passengers prefilled from the search form; the agent completes/edits identity before prebooking.
   *
   * @generated from field: repeated mobility.v1.Passenger passengers = 1;
   */
  passengers: Passenger[];

  /**
   * Detailed journey segments (per-leg times, train name/number, logo) of the chosen solution.
   *
   * @generated from field: repeated booking.v1.TrainRecapSegment segments = 2;
   */
  segments: TrainRecapSegment[];

  /**
   * The fare chosen at ChooseSolution (class / conditions / price).
   *
   * @generated from field: mobility.v1.Fare selected_fare = 3;
   */
  selectedFare?: Fare;

  /**
   * Add-ons offered for this train (luggage, bike, stroller, pet).
   *
   * @generated from field: repeated booking.v1.Ancillary available_ancillaries = 4;
   */
  availableAncillaries: Ancillary[];

  /**
   * Seat placement preference categories offered for this train (window/aisle, coach type...), per segment.
   *
   * @generated from field: repeated booking.v1.SeatPreferenceCategory available_seat_preferences = 5;
   */
  availableSeatPreferences: SeatPreferenceCategory[];

  /**
   * Segment IDs for which an interactive seatmap is available via GetSeatMap. Empty if none.
   *
   * @generated from field: repeated string seat_map_segment_ids = 6;
   */
  seatMapSegmentIds: string[];

  /**
   * Ancillaries preselected from the search form (e.g. animals), among available_ancillaries.
   *
   * @generated from field: repeated booking.v1.SelectedAncillary default_selected_ancillaries = 7;
   */
  defaultSelectedAncillaries: SelectedAncillary[];
};

/**
 * Describes the message booking.v1.TrainPrebookContext.
 * Use `create(TrainPrebookContextSchema)` to create a new message.
 */
export const TrainPrebookContextSchema: GenMessage<TrainPrebookContext> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 59);

/**
 * SeatPreferenceOption - a selectable value within a seat preference category (e.g. "window").
 *
 * @generated from message booking.v1.SeatPreferenceOption
 */
export type SeatPreferenceOption = Message<"booking.v1.SeatPreferenceOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message booking.v1.SeatPreferenceOption.
 * Use `create(SeatPreferenceOptionSchema)` to create a new message.
 */
export const SeatPreferenceOptionSchema: GenMessage<SeatPreferenceOption> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 60);

/**
 * SeatPreferenceCategory - a seat preference axis offered for a segment (e.g. seat placement, coach type).
 *
 * @generated from message booking.v1.SeatPreferenceCategory
 */
export type SeatPreferenceCategory = Message<"booking.v1.SeatPreferenceCategory"> & {
  /**
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: repeated booking.v1.SeatPreferenceOption options = 4;
   */
  options: SeatPreferenceOption[];
};

/**
 * Describes the message booking.v1.SeatPreferenceCategory.
 * Use `create(SeatPreferenceCategorySchema)` to create a new message.
 */
export const SeatPreferenceCategorySchema: GenMessage<SeatPreferenceCategory> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 61);

/**
 * RentalVehiclePrebookContext - recalled driver plus the chosen agency and vehicle.
 *
 * @generated from message booking.v1.RentalVehiclePrebookContext
 */
export type RentalVehiclePrebookContext = Message<"booking.v1.RentalVehiclePrebookContext"> & {
  /**
   * Driver prefilled from the search form (name/phone/birthdate). Licence fields are captured at
   * prebook time and are left empty here.
   *
   * @generated from field: mobility.v1.RentalVehicleDriver driver = 1;
   */
  driver?: RentalVehicleDriver;

  /**
   * Chosen pickup agency.
   *
   * @generated from field: mobility.v1.TransportAgency agency = 2;
   */
  agency?: TransportAgency;

  /**
   * Chosen vehicle.
   *
   * @generated from field: mobility.v1.VehicleProperties vehicle_properties = 3;
   */
  vehicleProperties?: VehicleProperties;

  /**
   * @generated from field: string vehicle_label = 4;
   */
  vehicleLabel: string;

  /**
   * @generated from field: string image_url = 5;
   */
  imageUrl: string;

  /**
   * @generated from field: mobility.v1.Price price = 6;
   */
  price?: Price;

  /**
   * Booking terms: cancellation policy, fuel, mileage, deposit, etc. (Markdown).
   *
   * @generated from field: string booking_conditions = 7;
   */
  bookingConditions: string;

  /**
   * Return agency.
   *
   * @generated from field: mobility.v1.TransportAgency return_agency = 8;
   */
  returnAgency?: TransportAgency;

  /**
   * category_class is the agency's rate card category letter, falling back to the ACRISS
   * category letter (e.g. "B", "E", "C") -- see
   * mobility_search.v1.RentalVehicleOffer.category_class for the same concept at search time.
   *
   * @generated from field: string category_class = 9;
   */
  categoryClass: string;
};

/**
 * Describes the message booking.v1.RentalVehiclePrebookContext.
 * Use `create(RentalVehiclePrebookContextSchema)` to create a new message.
 */
export const RentalVehiclePrebookContextSchema: GenMessage<RentalVehiclePrebookContext> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 62);

/**
 * TaxiPrebookContext - recalled taxi passenger count and the chosen taxi's estimated price.
 *
 * @generated from message booking.v1.TaxiPrebookContext
 */
export type TaxiPrebookContext = Message<"booking.v1.TaxiPrebookContext"> & {
  /**
   * Recalled passenger count from the search form.
   *
   * @generated from field: int32 passengers_count = 1;
   */
  passengersCount: number;

  /**
   * Estimated total price of the chosen taxi when it is available.
   *
   * @generated from field: mobility.v1.Price price = 2;
   */
  price?: Price;

  /**
   * Provider product label of the chosen taxi (e.g. "Standard"). Empty when the provider gave none.
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * Seats the chosen taxi can carry. Zero when the provider gave no capacity.
   *
   * @generated from field: int32 max_passenger_capacity = 4;
   */
  maxPassengerCapacity: number;

  /**
   * Time before the taxi reaches the pickup point. Unset when the provider gave no approach estimate.
   *
   * @generated from field: optional google.protobuf.Duration estimated_approach_duration = 5;
   */
  estimatedApproachDuration?: Duration;
};

/**
 * Describes the message booking.v1.TaxiPrebookContext.
 * Use `create(TaxiPrebookContextSchema)` to create a new message.
 */
export const TaxiPrebookContextSchema: GenMessage<TaxiPrebookContext> = /*@__PURE__*/
  messageDesc(file_booking_v1_booking, 63);

/**
 * RefundStatus - lifecycle status of a refund.
 *
 * @generated from enum booking.v1.RefundStatus
 */
export enum RefundStatus {
  /**
   * @generated from enum value: REFUND_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REFUND_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: REFUND_STATUS_REFUNDED = 2;
   */
  REFUNDED = 2,

  /**
   * @generated from enum value: REFUND_STATUS_CANCELED = 3;
   */
  CANCELED = 3,
}

/**
 * Describes the enum booking.v1.RefundStatus.
 */
export const RefundStatusSchema: GenEnum<RefundStatus> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 0);

/**
 * BookingItemFailureReason - why an item's last confirm attempt failed.
 *
 * @generated from enum booking.v1.BookingItemFailureReason
 */
export enum BookingItemFailureReason {
  /**
   * @generated from enum value: BOOKING_ITEM_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The provider rejected this item.
   *
   * @generated from enum value: BOOKING_ITEM_FAILURE_REASON_PROVIDER_ERROR = 1;
   */
  PROVIDER_ERROR = 1,

  /**
   * The item was never sent: an earlier item of the mission was rejected first.
   *
   * @generated from enum value: BOOKING_ITEM_FAILURE_REASON_NOT_ATTEMPTED = 2;
   */
  NOT_ATTEMPTED = 2,
}

/**
 * Describes the enum booking.v1.BookingItemFailureReason.
 */
export const BookingItemFailureReasonSchema: GenEnum<BookingItemFailureReason> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 1);

/**
 * BookingStatus - lifecycle status of a booking after prebook or confirmation.
 *
 * @generated from enum booking.v1.BookingStatus
 */
export enum BookingStatus {
  /**
   * @generated from enum value: BOOKING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BOOKING_STATUS_NOT_BOOKED = 2;
   */
  NOT_BOOKED = 2,

  /**
   * @generated from enum value: BOOKING_STATUS_PREBOOKED = 3;
   */
  PREBOOKED = 3,

  /**
   * @generated from enum value: BOOKING_STATUS_CONFIRMED = 4;
   */
  CONFIRMED = 4,

  /**
   * @generated from enum value: BOOKING_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: BOOKING_STATUS_ERROR = 6;
   */
  ERROR = 6,

  /**
   * A driver has picked up a taxi mission (still in progress or already completed).
   *
   * @generated from enum value: BOOKING_STATUS_ACCEPTED = 7;
   */
  ACCEPTED = 7,
}

/**
 * Describes the enum booking.v1.BookingStatus.
 */
export const BookingStatusSchema: GenEnum<BookingStatus> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 2);

/**
 * GroundTransferBookingMode - how a ground transfer stage can be resolved.
 *
 * @generated from enum booking.v1.GroundTransferBookingMode
 */
export enum GroundTransferBookingMode {
  /**
   * @generated from enum value: GROUND_TRANSFER_BOOKING_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The user selects one of the listed alternatives.
   *
   * @generated from enum value: GROUND_TRANSFER_BOOKING_MODE_ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * No online booking: the beneficiary must call the assister back (e.g. to order the return taxi).
   *
   * @generated from enum value: GROUND_TRANSFER_BOOKING_MODE_CALLBACK = 2;
   */
  CALLBACK = 2,
}

/**
 * Describes the enum booking.v1.GroundTransferBookingMode.
 */
export const GroundTransferBookingModeSchema: GenEnum<GroundTransferBookingMode> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 3);

/**
 * GroundTransferStage - position of a ground transfer relative to primary transports.
 * Booking order must be respected: PRE_TRANSPORT → BETWEEN_PRIMARY_TRANSPORTS → POST_TRANSPORT.
 *
 * @generated from enum booking.v1.GroundTransferStage
 */
export enum GroundTransferStage {
  /**
   * @generated from enum value: GROUND_TRANSFER_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GROUND_TRANSFER_STAGE_PRE_TRANSPORT = 1;
   */
  PRE_TRANSPORT = 1,

  /**
   * @generated from enum value: GROUND_TRANSFER_STAGE_BETWEEN_PRIMARY_TRANSPORTS = 2;
   */
  BETWEEN_PRIMARY_TRANSPORTS = 2,

  /**
   * @generated from enum value: GROUND_TRANSFER_STAGE_POST_TRANSPORT = 3;
   */
  POST_TRANSPORT = 3,
}

/**
 * Describes the enum booking.v1.GroundTransferStage.
 */
export const GroundTransferStageSchema: GenEnum<GroundTransferStage> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 4);

/**
 * NextActionStep - the step the frontend must perform next to advance the booking flow.
 *
 * @generated from enum booking.v1.NextActionStep
 */
export enum NextActionStep {
  /**
   * @generated from enum value: NEXT_ACTION_STEP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The frontend must call PrebookTransport for the referenced primary transport.
   *
   * @generated from enum value: NEXT_ACTION_STEP_PREBOOK_PRIMARY_TRANSPORT = 1;
   */
  PREBOOK_PRIMARY_TRANSPORT = 1,

  /**
   * The frontend must call SelectGroundTransfer or SkipGroundTransfer for the referenced ground transfer stage.
   *
   * @generated from enum value: NEXT_ACTION_STEP_SELECT_OR_SKIP_GROUND_TRANSFER = 2;
   */
  SELECT_OR_SKIP_GROUND_TRANSFER = 2,

  /**
   * All transports have been handled. The frontend must call ConfirmBookings.
   *
   * @generated from enum value: NEXT_ACTION_STEP_CONFIRM_MISSION = 3;
   */
  CONFIRM_MISSION = 3,
}

/**
 * Describes the enum booking.v1.NextActionStep.
 */
export const NextActionStepSchema: GenEnum<NextActionStep> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 5);

/**
 * GroundTransferDecision - what the traveller chose for a ground transfer stage. Whether the chosen
 * option is bookable online is a separate axis: see GroundTransferBookingMode.
 *
 * @generated from enum booking.v1.GroundTransferDecision
 */
export enum GroundTransferDecision {
  /**
   * @generated from enum value: GROUND_TRANSFER_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A ground transfer option was selected for this stage.
   *
   * @generated from enum value: GROUND_TRANSFER_DECISION_SELECTED = 1;
   */
  SELECTED = 1,

  /**
   * The ground transfer was skipped for this stage.
   *
   * @generated from enum value: GROUND_TRANSFER_DECISION_SKIPPED = 2;
   */
  SKIPPED = 2,

  /**
   * The ground transfer slot is still awaiting a decision (neither selected nor skipped yet).
   *
   * @generated from enum value: GROUND_TRANSFER_DECISION_PENDING = 3;
   */
  PENDING = 3,
}

/**
 * Describes the enum booking.v1.GroundTransferDecision.
 */
export const GroundTransferDecisionSchema: GenEnum<GroundTransferDecision> = /*@__PURE__*/
  enumDesc(file_booking_v1_booking, 6);

/**
 * BookingCommandService - handles write operations for booking lifecycle (prebook, confirm, skip).
 *
 * @generated from service booking.v1.BookingCommandService
 */
export const BookingCommandService: GenService<{
  /**
   * Holds a primary transport option temporarily (TTL applies).
   *
   * @generated from rpc booking.v1.BookingCommandService.PrebookTransport
   */
  prebookTransport: {
    methodKind: "unary";
    input: typeof PrebookTransportRequestSchema;
    output: typeof PrebookTransportResponseSchema;
  },
  /**
   * Releases the primary transport hold and reopens the prebook step, so the traveller can go back
   * to an earlier step of the flow. Ground transfer decisions are kept. Fails once any item is booked.
   *
   * @generated from rpc booking.v1.BookingCommandService.ReleasePrimaryTransport
   */
  releasePrimaryTransport: {
    methodKind: "unary";
    input: typeof ReleasePrimaryTransportRequestSchema;
    output: typeof ReleasePrimaryTransportResponseSchema;
  },
  /**
   * Changes the main rental vehicle's pickup/return period before prebook and reprices it for
   * the new duration.
   *
   * @generated from rpc booking.v1.BookingCommandService.UpdateRentalVehicleSchedule
   */
  updateRentalVehicleSchedule: {
    methodKind: "unary";
    input: typeof UpdateRentalVehicleScheduleRequestSchema;
    output: typeof UpdateRentalVehicleScheduleResponseSchema;
  },
  /**
   * Quotes pushing back a booked rental vehicle's return, without changing the provider booking.
   * ExtendRentalVehicle performs it.
   *
   * @generated from rpc booking.v1.BookingCommandService.QuoteRentalVehicleExtension
   */
  quoteRentalVehicleExtension: {
    methodKind: "unary";
    input: typeof QuoteRentalVehicleExtensionRequestSchema;
    output: typeof QuoteRentalVehicleExtensionResponseSchema;
  },
  /**
   * Pushes back a booked rental vehicle's return, keeping the same vehicle, return agency and
   * provider booking. The extra days are added to the rental price.
   *
   * @generated from rpc booking.v1.BookingCommandService.ExtendRentalVehicle
   */
  extendRentalVehicle: {
    methodKind: "unary";
    input: typeof ExtendRentalVehicleRequestSchema;
    output: typeof ExtendRentalVehicleResponseSchema;
  },
  /**
   * Selects a ground transfer option for a given stage of the mission.
   * ground_transfer_id comes from ListGroundTransferAlternative.
   *
   * @generated from rpc booking.v1.BookingCommandService.SelectGroundTransfer
   */
  selectGroundTransfer: {
    methodKind: "unary";
    input: typeof SelectGroundTransferRequestSchema;
    output: typeof SelectGroundTransferResponseSchema;
  },
  /**
   * Skips a non-mandatory ground transfer for a given stage.
   *
   * @generated from rpc booking.v1.BookingCommandService.SkipGroundTransfer
   */
  skipGroundTransfer: {
    methodKind: "unary";
    input: typeof SkipGroundTransferRequestSchema;
    output: typeof SkipGroundTransferResponseSchema;
  },
  /**
   * Triggers firm booking of all prebooked transports for a mission in parallel.
   * All ground transfers must be selected or skipped before this can be called.
   *
   * @generated from rpc booking.v1.BookingCommandService.ConfirmBookings
   */
  confirmBookings: {
    methodKind: "unary";
    input: typeof ConfirmBookingsRequestSchema;
    output: typeof ConfirmBookingsResponseSchema;
  },
  /**
   * Quotes cancelling a booked item, without performing anything on the provider side.
   * ValidateRefund confirms a quote returned here.
   *
   * @generated from rpc booking.v1.BookingCommandService.CreateRefund
   */
  createRefund: {
    methodKind: "unary";
    input: typeof CreateRefundRequestSchema;
    output: typeof CreateRefundResponseSchema;
  },
  /**
   * Confirms one or more pending refund quotes CreateRefund returned, performing the
   * cancellation on the provider.
   *
   * @generated from rpc booking.v1.BookingCommandService.ValidateRefund
   */
  validateRefund: {
    methodKind: "unary";
    input: typeof ValidateRefundRequestSchema;
    output: typeof ValidateRefundResponseSchema;
  },
  /**
   * Discards one or more pending refund quotes CreateRefund returned, without performing
   * anything on the provider side.
   *
   * @generated from rpc booking.v1.BookingCommandService.CancelRefund
   */
  cancelRefund: {
    methodKind: "unary";
    input: typeof CancelRefundRequestSchema;
    output: typeof CancelRefundResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_booking_v1_booking, 0);

/**
 * BookingQueryService - handles read operations for booking state and confirmation details.
 *
 * @generated from service booking.v1.BookingQueryService
 */
export const BookingQueryService: GenService<{
  /**
   * @generated from rpc booking.v1.BookingQueryService.GetPlan
   */
  getPlan: {
    methodKind: "unary";
    input: typeof GetPlanRequestSchema;
    output: typeof GetPlanResponseSchema;
  },
  /**
   * Returns the pre-confirmation summary for all bookings of a mission.
   *
   * @generated from rpc booking.v1.BookingQueryService.ListMissionBookings
   */
  listMissionBookings: {
    methodKind: "unary";
    input: typeof ListMissionBookingsRequestSchema;
    output: typeof ListMissionBookingsResponseSchema;
  },
  /**
   * Lists booking summaries across all missions, for the admin operations view (not scoped to a
   * single mission, unlike ListMissionBookings).
   *
   * @generated from rpc booking.v1.BookingQueryService.ListBookings
   */
  listBookings: {
    methodKind: "unary";
    input: typeof ListBookingsRequestSchema;
    output: typeof ListBookingsResponseSchema;
  },
  /**
   * Returns the raw JSON of the mission's booking core (the zeus aggregate, as persisted), for the
   * admin operations view. Debug/support tooling only -- not for customer-facing display.
   *
   * @generated from rpc booking.v1.BookingQueryService.GetBookingCore
   */
  getBookingCore: {
    methodKind: "unary";
    input: typeof GetBookingCoreRequestSchema;
    output: typeof GetBookingCoreResponseSchema;
  },
  /**
   * Streams real-time booking status updates until all bookings reach a terminal status.
   *
   * @generated from rpc booking.v1.BookingQueryService.StreamConfirmationStatus
   */
  streamConfirmationStatus: {
    methodKind: "server_streaming";
    input: typeof StreamConfirmationStatusRequestSchema;
    output: typeof StreamConfirmationStatusResponseSchema;
  },
  /**
   * Returns the available ground transfer alternatives for a given stage of a mobility solution.
   * Call this when NextAction.step == SELECT_OR_SKIP_GROUND_TRANSFER.
   *
   * @generated from rpc booking.v1.BookingQueryService.ListGroundTransferAlternatives
   */
  listGroundTransferAlternatives: {
    methodKind: "unary";
    input: typeof ListGroundTransferAlternativesRequestSchema;
    output: typeof ListGroundTransferAlternativesResponseSchema;
  },
  /**
   * Returns the current next action for a mission, enriched with the prebook context.
   *
   * @generated from rpc booking.v1.BookingQueryService.GetNextAction
   */
  getNextAction: {
    methodKind: "unary";
    input: typeof GetNextActionRequestSchema;
    output: typeof GetNextActionResponseSchema;
  },
  /**
   * Returns the raw seatmap payload for a train segment, to forward verbatim to the frontend's
   * seatmap widget. Call only for segment IDs listed in TrainPrebookContext.seat_map_segment_ids.
   *
   * @generated from rpc booking.v1.BookingQueryService.GetSeatMap
   */
  getSeatMap: {
    methodKind: "unary";
    input: typeof GetSeatMapRequestSchema;
    output: typeof GetSeatMapResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_booking_v1_booking, 1);

